const axios = require('axios')
const { entrypoints } = require('../const/entrypoints')

class PrivacyController {
  static async sendConsent(stage, hash, consent, data) {
    try {
      return await axios.post(`${entrypoints[stage].controllerURL}/consent/${hash}/${consent}`, data)
    } catch (err) {
      //-
    }
  }
}

module.exports.PrivacyController = PrivacyController
